import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthWrapper, { AuthProvider } from './AuthWrapper';
import LandingPageExact from './LandingPageExact';
import DownloadPage from './DownloadPage';
import DownloadSoon from './DownloadSoon';
import AdminPage from './AdminPage';
import IDELoginCallback from './IDELoginCallback';
import IDELoginDirect from './IDELoginDirect';
import Dashboard from './Dashboard';
import VerifyEmail from './VerifyEmail';
import ResetPassword from './ResetPassword';
import PricingPage from './PricingPage';
import BillingPage from './BillingPage';
import { Toaster } from './ui/toaster';

// Main Router Component
export const AppRouter = () => {
  return (
    <BrowserRouter>
      {/* Toaster for toast notifications - must be outside Routes to be always visible */}
      <Toaster />
      <Routes>
        {/* Landing page route */}
        <Route path="/" element={<LandingPageExact />} />
        
        {/* Download page - public "available soon" page (header nav) */}
        <Route path="/downloads" element={<DownloadSoon />} />
        
        {/* Download page - real downloads (secret URL) */}
        <Route path="/get" element={<DownloadPage />} />
        
        {/* Redirect /download to /downloads (coming soon) so old URL doesn't expose secret page */}
        <Route path="/download" element={<Navigate to="/downloads" replace />} />
        
        {/* Admin panel - protected by admin key */}
        <Route path="/admin" element={<AdminPage />} />
        
        {/* Dashboard route - requires authentication */}
        <Route 
          path="/dashboard" 
          element={
            <AuthWrapper>
              <Dashboard />
            </AuthWrapper>
          } 
        />
        
        {/* IDE (VS Code fork) login callback route */}
        <Route 
          path="/ide-login" 
          element={
            <AuthWrapper>
              <IDELoginCallback />
            </AuthWrapper>
          } 
        />
        
        {/* IDE direct login with loopback callback - uses AuthProvider directly to access auth state without blocking */}
        <Route
          path="/ide-login-direct"
          element={
            <AuthProvider>
              <IDELoginDirect />
            </AuthProvider>
          }
        />

        {/* Email verification page */}
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Password reset page */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Pricing page (public) */}
        <Route path="/pricing" element={<PricingPage />} />

        {/* Billing management page (requires auth) */}
        <Route
          path="/billing"
          element={
            <AuthWrapper>
              <BillingPage />
            </AuthWrapper>
          }
        />

        {/* Catch all - redirect to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;

